import React from 'react'
import { useTranslation } from 'react-i18next'
import { ManagementEmptyDescriptionUi } from './ui/management-empty-description-ui'
import { ManagementEmptyTitleUi } from './ui/management-empty-title-ui'
import { ManagementEmptyUi } from './ui/management-empty-ui'

export const ManagementEmpty = () => {
  const { t } = useTranslation()

  return (
    <ManagementEmptyUi>
      <ManagementEmptyTitleUi>
        {t('popup_management.empty_title')}
      </ManagementEmptyTitleUi>
      <ManagementEmptyDescriptionUi>
        <span>{t('popup_management.empty_list')}</span>
      </ManagementEmptyDescriptionUi>
    </ManagementEmptyUi>
  )
}
